import React from "react";
import { withTranslation } from "react-i18next";
import "./styles/Complete.css";

class Complete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkmark: "https://spare-cdn.s3.us-west-1.amazonaws.com/images/checkmark.png",
    };
  }

  render() {
    const { t } = this.props;

    return (
      <div className="complete-container">
        <div className="complete-center">
          <img
            src={this.state.checkmark}
            alt={t('altCheckmark')}
            className="complete-checkmark"
          />
          <h2 className="transation-complete">{t('title')}</h2>
          <p>{t('body')}</p>

          <input
            className="action-button btn"
            type="submit"
            value={t('button')}
            onClick={() => {
              this.props.history.push("/dashboard");
            }}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation('complete')(Complete);
